module.exports = __webpack_public_path__ + "img/partner_18.7ce4ba87.png";